import {TASKMANAGE} from 'Constants/ActionTypes';

const {
  SET_TASK_QUESTIONNAIRE_SEARCH_DATA,
  GET_TASK_QUESTIONNAIRE_CONNECT_PIE,
  GET_TASK_QUESTIONNAIRE_ANSWER_BAR,
  GET_TASK_QUESTIONNAIRE_RESULT,
  SET_TASK_QUESTIONNAIRE_PAGE_STATUS,
  GET_TASK_QUESTIONNAIRE_HEAD,
  SET_TABLEHEAD_SEARCH_DATA,
} = TASKMANAGE;

const initialState = {
  searchData: {
    startMillis: 0,
    endMillis: 0,
    taskId: 0,
  }, // 搜索条件
  pieData: [],
  barData: [],
  tableHead: {
    contentRecords: {},
    totalMax: 0,
    total: 0,
  },
  questionQueryReqs: {},
  tableListData: {
    data: [],
    max: 0,
    total: 0,
  }, // table数据
  pageStatus: {
    pageNum: 1,
    pageSize: 10,
  }, // pageNum与pageSize
};
const questionNaire = (state = initialState, action) => {
  switch (action.type) {
    case `${SET_TASK_QUESTIONNAIRE_SEARCH_DATA}`:
      return {
        ...state,
        searchData: action.data,
      };
    case `${GET_TASK_QUESTIONNAIRE_CONNECT_PIE}_SUCCESS`:
      return {
        ...state,
        pieData: (action.payload.data && action.payload.data) || [],
      };
    case `${GET_TASK_QUESTIONNAIRE_ANSWER_BAR}_SUCCESS`:
      return {
        ...state,
        barData: (action.payload.data && action.payload.data) || [],
      };
    case `${SET_TABLEHEAD_SEARCH_DATA}`:
      return {
        ...state,
        questionQueryReqs: action.data,
      };
    case `${GET_TASK_QUESTIONNAIRE_HEAD}_SUCCESS`:
      return {
        ...state,
        tableHead: {
          contentRecords:
            (action.payload.data && action.payload.data.contentRecords) || {},
          totalMax: (action.payload.data && action.payload.data.totalMax) || 0,
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${GET_TASK_QUESTIONNAIRE_RESULT}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.data) || [],
          max: (action.payload.data && action.payload.data.max) || 0,
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${SET_TASK_QUESTIONNAIRE_PAGE_STATUS}`:
      return {
        ...state,
        pageStatus: {...state.pageStatus, ...action.data},
      };
    default:
      return state;
  }
};
export default questionNaire;
